import get from 'lodash/fp/get';

export const getEvents = get('events');
